import {
  LOAD,
  SELECT
} from '../actions/usersActions';

const initialState = {
  user: {},
  data: []
};

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOAD:
      return { 
        ...state,
        data: action.data
      };
    case SELECT:
      return { 
        ...state,
        user: action.user
      };
    default:
      return state;
  }
};

export default userReducer;
